import { CustomElement } from '@aurelia/runtime-html';
import * as d0 from "../../value-converters/price-format.js";
export const name = "price-display";
export const template = "<template>\r\n    \r\n\r\n    <span class=\"text-[22px] gap-1 text-nowrap font-bold flex items-center ${ showHighlightClass ? 'e3-animate-price-change' : '' }\">\r\n        <span class=\"text-xs\">${aurelia_options.translations.lmt_triplist_body_price_prefix}</span> \r\n        ${price | priceFormat} \r\n        <span class=\"text-xs\">€</span>\r\n    </span>\r\n</template>\r\n";
export default template;
export const dependencies = [ d0 ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
